<template>
    <div class="customer-detail-message">
        <table>
            <!-- <pt-message-table-item label="用户名">
                {{userDetail.nickname}}
            </pt-message-table-item> -->
            <pt-message-table-item label="姓名">
                {{userDetail.fullName}}
            </pt-message-table-item>
            <pt-message-table-item label="手机号">
                {{userDetail.mobile}}
            </pt-message-table-item>
            <pt-message-table-item label="性别">
                {{userDetail.sex}}
            </pt-message-table-item>
            <pt-message-table-item label="当前等级" >
              {{levelDetail.levelName}}会员（{{levelDetail.levelChangeTime}}）
              <div :class="$style['specification-table-div']" class="page-background">
                <table :class="$style['specification-table']">
                  <th>
                  <td>会员等级历史</td>
                  <td>等级变更时间</td>
                  <td>变更类型</td>
                  </th>
                  <tr v-for="(item,index) in levelDetail.userMemberLevelLogList" :key="index">
                    <td>{{item.levelName}}</td>
                    <td>{{item.createdDate}} </td>
                    <td>{{item.level_change_type}}</td>
                  </tr>
                </table>
              </div>
            </pt-message-table-item>
            <pt-message-table-item label="生日">
                {{userDetail.birthday_date}}
            </pt-message-table-item>
            <pt-message-table-item label="证件类型">
                {{userDetail.idCardType}}
            </pt-message-table-item>
             <pt-message-table-item label="证件号">
                 {{userDetail.identityCard}}
             </pt-message-table-item>
            <pt-message-table-item label="微信所在地">
                {{userDetail.city}}
            </pt-message-table-item>
            <pt-message-table-item label="CPS所在地">
                {{businessInformation.city}}
            </pt-message-table-item>
            <pt-message-table-item label="业务来源">
                {{userDetail.sourceName}}
            </pt-message-table-item>
            <pt-message-table-item label="已注册">
                {{userDetail.is_registry}}
            </pt-message-table-item>
            <pt-message-table-item label="注册时间">
                {{userDetail.registry_time}}
            </pt-message-table-item>
            <pt-message-table-item label="邀请人">
                <span :class="$style['invitation-user-name']" v-if="userDetail.invitationUserName" @click="getInvitattionUser">{{userDetail.invitationUserName}}</span>
                <template v-else>--</template><span :class="$style['invitation-class']">(邀请该用户注册为生命银行用户的人)</span>
            </pt-message-table-item>
            <pt-message-table-item label="邀请人手机号">
                {{userDetail.invitationUserMobile||'--'}}
            </pt-message-table-item>
            <pt-message-table-item label="是否绑定CPS合同">
                {{userDetail.isCPS}}
            </pt-message-table-item>
              <pt-message-table-item label="是否为家系用户">
                {{userDetail.isFamily}}
            </pt-message-table-item>
              <pt-message-table-item label="成为家系用户时间">
                {{userDetail.family_date}}
            </pt-message-table-item>
            <pt-message-table-item label="医护人员">
              <template v-if="userDetail.doctor">
              <router-link  :class="$style['doctor-or-counselor']" v-if="userDetail.doctor.name" :to="'/doctor-detail/'+userDetail.doctor.id">
                {{userDetail.doctor.name}}
              </router-link>
              <template v-else>--</template>
              </template>
              <template v-else>否</template>
              <!-- {{!!userDetail.doctor?userDetail.doctor.name:'否'}} -->
              </pt-message-table-item>
            <pt-message-table-item label="业务员">
              <template v-if="userDetail.counselor">
              <router-link :class="$style['doctor-or-counselor']" v-if="userDetail.counselor.id" :to="'/pt-counselor-detail/'+userDetail.counselor.id">
              {{userDetail.counselor.firstName}}
              </router-link>
              <template v-else>--</template>
              </template>
              <template v-else>否</template>
              </pt-message-table-item>
            <pt-message-table-item label="注册到CPS">
              <template>
                <el-button @click="registryCps" type="text">注册</el-button>
              </template>
            </pt-message-table-item>
        </table>
        <template>
          <pt-sub-title title="微信信息"></pt-sub-title>
          <table  v-if="wxDetail.id">
            <pt-message-table-item label="微信昵称">
              <template>
                {{wxDetail.nickname}}
              </template>
            </pt-message-table-item>
            <pt-message-table-item label="openId">
              <template>
                {{wxDetail.openId}}
              </template>
            </pt-message-table-item>
            <pt-message-table-item label="unionId">
              <template>
                {{wxDetail.unionId}}
              </template>
            </pt-message-table-item>
            <pt-message-table-item label="微信解绑">
              <template>
                <el-button @click="unbindWx(wxDetail.id)" type="text">解绑</el-button>
              </template>
            </pt-message-table-item>
          </table>
          <div v-else :class="$style['unbounded']">该用户未绑定微信</div>
        </template>
        <template>
        <pt-sub-title title="收货地址信息"></pt-sub-title>
        <wt-table :labels="shippingAddressLabel" :list="shippingAddresses">
        </wt-table>
        </template>
    </div>
</template>
<script>
import { shippingAddressLabel } from './customer-detail-option'
export default {
  computed: {
    businessInformation () {
      return this.userDetail.businessInformation || {}
    }
  },
  props: {
    userDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    wxDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    shippingAddresses: {
      type: Array,
      default: function () {
        return []
      }
    },
    levelDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      shippingAddressLabel: shippingAddressLabel
    }
  },
  methods: {
    getInvitattionUser () {
      this.$router.push('/all-customer/customer-detail/' + this.userDetail.invitationUserId + '?state=basic-message')
    },
    unbindWx (val) {
      this.$emit('unbindWx', val)
    },
    registryCps () {
      this.$emit('registryCps')
    }
  }
}
</script>
<style module lang="less">
@import "~less/var";
.doctor-or-counselor{
  color:  @mainColor;
}
  .specification-table-div {
    margin-top:20px;
    padding: 0 .2rem .2rem;
  }

  .specification-table {
    display: table !important;
    min-width: 5rem;
    border-collapse: collapse !important;

    th,
    tr {
      width: 100% !important;
      max-width: 100% !important;
      display: table-row !important;
      padding: 0 !important;
      list-style-type: none;
      justify-content: center !important;
      border-bottom: 1px solid #C6C9D3;
      color: #5B5B5B !important;
    }

    td {
      color: #5B5B5B !important;
      text-align: center;
      justify-content: flex-start !important;
      padding: 10px;
    }
  }
  .invitation-class{
    color: #5B5B5B;
    font-size: 13px;
    margin-left:10px
  }
  .invitation-user-name{
    color: #edbe81
  }
  .unbounded {
    text-align:center;
    color: #909399
  }
</style>
<style lang="less">
.customer-detail-message{
  padding:20px;
  .el-button{
    height: .3rem!important;
    line-height: 0;
  }
}

</style>
